import { createClient } from '@supabase/supabase-js';

export const supabase = createClient(
  'https://viyhjusnfdwczvbjgttm.supabase.co',
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZpeWhqdXNuZmR3Y3p2YmpndHRtIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzM5NDEzMzEsImV4cCI6MjA4OTUxNzMzMX0.8VGs9LPk3DsffJxbk__Inaj1K8CBZmq7C2bKxj_2RxQ'
);
